
import spouses from '@/components/pages/guests/mixins/spouses'
import hasPageMeta from '@/mixins/hasPageMeta'
import { mapState } from 'vuex'

export default {
    layout: 'empty',

    mixins: [spouses, hasPageMeta],

    async fetch() {
        await this.$axios.$get(`/api/v1/public/users/${this.$route.params.username}`).then((res) => {
            this.model = res.data
        })
    },

    data() {
        return {
            model: {},
        }
    },

    computed: {
        ...mapState({
            globalTexts: (state) => state.jsonloader.data['global.json'] || null,
            user: (state) => state.auth.user || {},
        }),

        siteTitle() {
            return `${this.spouses} want to know if you plan to attend their wedding events.`
        },

        siteDescription() {
            return `Will you be joining us? We kindly request your reply by ${this.weddingDate}. Thanks a bunch.`
        },

        previewImage() {
            return this.imageSrc || require('@/static/guest-list/rsvp-preview.jpg')
        },

        imageSrc() {
            const model = this.model?.user || this.model
            if (model && model.guest_form_template) {
                if (model?.guest_form_template)
                    return model.guest_form_template.rsvp?.photo?.url || require('@/static/guest-list/Loverly_GuestListUserCover.jpg')
            }
            return require('@/static/guest-list/Loverly_GuestListUserCover.jpg')
        },

        showEditButton() {
            return this.user?.username === this.$route.params.username
        },
    },

    methods: {
        getField(fieldKey, objKey, placeholderKey) {
            const model = this.model?.user || this.model
            if (!model) return ''
            if (model.guest_form_template && model.guest_form_template[objKey])
                if (model?.guest_form_template[objKey][fieldKey]) return model.guest_form_template[objKey][fieldKey]
            return this.getPlaceholder(placeholderKey)
        },
    },
}
